<template>
  <div>
    <div class="modal__parking-board-template-wrapper">
      <div
          v-for="item in parkingBoards"
          :key="item.id"
          class="modal__parking-item"
      >
        <div class="modal__parking-name">
          <translated-text-component translation="parking_board_name" />
          {{ item.name }} 
        </div>
        <div class="modal__parking-row">
          <div class="modal__parking-desc">
            {{ item.description }} 
          </div>
          <div v-if="item.last_status" class="modal__parking-count">
            <div v-if="item.last_status.available_car_parking_spots
            || item.last_status.available_car_parking_spots == 0" class="modal__parking-zone-count">
              <div class="modal__subtitle">
                <translated-text-component translation="modal_parking_free_spaces_amount" />
              </div>
              <div :style="{'color': item.last_status.text_color}" class="modal__parking-zone-count-value">
                {{item.last_status.available_car_parking_spots}}
              </div>
            </div>
            <!-- <div v-if="item.last_status.text" class="modal__parking-zone-count">
              <div :style="{'color': item.last_status.text_color}" class="modal__subtitle">
                {{item.last_status.text}}
              </div>
            </div> -->
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import { IModalData } from '@/services/layers/IModalData';
import moment from 'moment';

const TemplateModalParkingBoard: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const parkingBoards: Ref<Array<any>> = ref([]);

    onMounted(() => {
      const { metaData } = props.templateData;
      parkingBoards.value = metaData.parking_boards;
    });

    return {
      parkingBoards,
    };
  },
});
export default TemplateModalParkingBoard;
</script>

<style scoped lang="scss">
.modal__parking {
  &-item {
    text-align: center;
    border: 1px solid currentColor;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #000000;
  }
  &-name {
    font-weight: 700;
    margin-bottom: 10px;
  }
}
.modal__parking-zone {
  &-box {
    text-align: center;
    margin-bottom: 14px;
  }

  &-count {
    &-value {
      font-weight: 700;
    }
  }
}
</style>
